import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import bgOverlay from "../assets/images/refer-friend-bg.jpg";
import androiddownloadimg from "../assets/images/playstorebtnlighttheme.png";
const SportsDraftAuction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative w-full py-16 px-4 bg-[#FFC700] overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgOverlay})`,
      }}
    >
      {/* Top Heading */}
      <div className="relative z-10 text-center mb-12">
        <h2 className="text-[32px] md:text-[48px] font-oswald font-extrabold text-[#070B28] leading-tight">
          Sports Draft Picker
        </h2>
        <img
          src={underlineimage}
          alt="underline"
          className="mx-auto mt-2 mb-6 w-[120px] h-auto"
        />
      </div>

      {/* Content & Video */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row-reverse items-center justify-center gap-[6rem] px-6">
        {/* Right Side - Video */}
        <div className="md:w-1/2">
          <div className="aspect-w-16 aspect-h-9 w-full">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/RhdZy3vrEcg"
              title="GamerJi Tournament Services"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded-lg shadow-lg"
            ></iframe>
          </div>
        </div>

        {/* Left Side - Text Content */}
        <div className="md:w-1/2 text-left">
          <p className="text-[28px] leading-[40px] font-semibold text-[#070B28] mb-[10px] font-proxima">
             Get over the usual boring fantasy games and pick players which are unique to your team
          </p>
        </div>
      </div>
    </div>
  );
};

export default SportsDraftAuction;
